import OrganizationPublicKeysTable from "./OrganizationPublicKeysTable";

export default OrganizationPublicKeysTable;

export { OrganizationPublicKeysTable };
